import { render } from "./TrendDetailModal.vue?vue&type=template&id=534b1728&ts=true"
import script from "./TrendDetailModal.vue?vue&type=script&lang=ts"
export * from "./TrendDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__